import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from "react-redux";
import TablePagination from '@mui/material/Pagination';
import { fetchShowboxData, switchApiPage } from '../../../FlikTraxStore/Actions/apiActions';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

const ShowBoxPaginator = () => {

  const dispatch = useDispatch();
  const Url = require('url-parse');
  const UrlObj = new Url(window.location.href);
  const collectionQuery = UrlObj['query'].split("=");
  const collectionID = collectionQuery[1];
  const apiData = useSelector((state) => state.api && state.api.showboxData);
  const handleChangePage = (event, newPage) => {
    dispatch(switchApiPage(newPage));
    dispatch(fetchShowboxData(collectionID));
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  //if (!dataIsLoading && apiData) {
    return (
        <Grid container style={{margin:25}}>
            <Grid item >
                <TablePagination
                    // sx={{ marginBottom: '1rem', marginTop: '1rem' }}
                    size="small"
                    variant="outlined"
                    defaultPage={1}
                    shape="rounded"
                    siblingCount={3}
                    boundaryCount={1}
                    showFirstButton={apiData.page > 2 ? true: false}
                    showLastButton={apiData.page < apiData.page_count ? true: false}
                    colSpan={7}
                    count={apiData.page_count}
                    page={apiData.page}
                    onChange={handleChangePage}
                />

            </Grid>
            <Grid item>
            <Typography noWrap variant="caption" style={{color:'#1c749c', marginLeft:25}}>
                    Displaying page {apiData.page} of {apiData.page_count} ({apiData.total_items} Total Tracks)
                </Typography>
            </Grid>
        </Grid>

    );
  // } else {
  //   return null;
  // }
}

ShowBoxPaginator.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default (ShowBoxPaginator);